import { render, staticRenderFns } from "./HomeBrandsBanner.vue?vue&type=template&id=47ea5fa6&scoped=true"
import script from "./HomeBrandsBanner.vue?vue&type=script&lang=js"
export * from "./HomeBrandsBanner.vue?vue&type=script&lang=js"
import style0 from "./HomeBrandsBanner.vue?vue&type=style&index=0&id=47ea5fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea5fa6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrandLogo: require('/app/components/BrandLogo.vue').default})
